import React, {Component} from 'react';
import {Table, Button} from 'react-bootstrap';
import swal from 'sweetalert';
import {translate}	from 'react-i18next';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import {bin} from 'react-icons-kit/icomoon/bin';
import ModalDetails from './modalDetails';
import Help from '../../generics/help';

const Config = require('../../../config');

class SuppliesEntries extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.onDelete = this.onDelete.bind(this);

		this.state = {
			list:[]
		}
	}

	componentDidMount(){
		this.getList();
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'supplies_purchase/health_facilities_id='+
			sessionStorage.getItem('health_facilities_id'), {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					list: response
				});
			}
		});
	}

	newEntry(){
		this.props.history.push('/supplies_entries/new');
	}

	viewInformation(item){
		this.modal_details.handleShow(item);
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, (isConfirm) => {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'supplies_purchase?id='+id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
	        }
	    });
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Insumos ->
						Servicios Entrada  
					</h5>
				</div>


				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<input type="text" className="form-control" name="filter" id="filter" placeholder={"Filtro..."}
							value={this.state.filter} onChange={this.handleChange} />
						
					</div>

					<div className="col-xs-12 col-sm-1 col-sm-offset-9">
						<button type="button" className="btn btn-info" style={{fontSize:"14px"}}
							disabled={!this.props.supplies_entries.create}
							onClick={this.newEntry}>Nuevo</button>
					</div>
				</div>

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>Fecha Entrada</th>
								<th>Proveedor</th>
								<th>Folio Factura</th>
								<th>Fecha Factura</th>
								
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((l, i)=>(
								<tr key={i}>
									<td>{moment(l.purchase.entry_date).format('DD/MM/YYYY')}</td>
									<td>{l.provider}</td>
									<td>{l.purchase.purchase_folio}</td>
									<td>{l.purchase.purchase_date !== null ?  moment(l.purchase.purchase_date).format('DD/MM/YYYY') : ''}</td>
									<td>
										<Button className="btn btn-info btn-xs" title="Detalles" style={{marginRight:"5px"}} 
											onClick={this.viewInformation.bind(this, l)} >
											<SvgIcon icon={search}/>
										</Button>
										<Button className="btn btn-info btn-xs" title="Retirar" style={{marginRight:"5px"}}
											onClick={(e)=>this.onDelete(l.purchase.id)}
											disabled={!this.props.supplies_entries.delete} >
											<SvgIcon icon={bin} />
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>

				<ModalDetails {...this.props} onRef={ref => (this.modal_details = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(SuppliesEntries);